export default "__VITE_ASSET__eaa552e6__"